import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Briefcase, Rocket } from "lucide-react";

export default function EmploymentStep({ form, setForm, loading, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="space-y-5">
      <div>
        <Label className="text-xs uppercase tracking-widest text-slate-600 font-semibold">Employment Type</Label>
        <div className="grid grid-cols-2 gap-4 mt-3">
          {["salaried", "self_employed"].map(type => (
            <button key={type} type="button" data-testid={`employment-${type}`}
              onClick={() => setForm({...form, employment_type: type})}
              className={`p-5 border-2 rounded-xl text-sm font-semibold transition-all duration-300 flex flex-col items-center justify-center gap-2 ${
                form.employment_type === type
                  ? 'border-blue-500 bg-gradient-to-br from-blue-50 to-cyan-50 text-blue-700 shadow-lg scale-105'
                  : 'border-slate-200 text-slate-600 hover:border-slate-300 bg-white/50'
              }`}>
              {type === "salaried"
                ? <Briefcase className="h-5 w-5" strokeWidth={2.2} />
                : <Rocket className="h-5 w-5" strokeWidth={2.2} />}
              <span>{type === "salaried" ? "Salaried" : "Self Employed"}</span>
            </button>
          ))}
        </div>
      </div>
      <div>
        <Label className="text-xs uppercase tracking-widest text-slate-600 font-semibold">Monthly Income (INR)</Label>
        <Input data-testid="income-input" type="number" value={form.monthly_income} onChange={e => setForm({...form, monthly_income: e.target.value})} placeholder="e.g. 50000" className="mt-2 bg-white/50 border-slate-200 focus:border-blue-500 h-12" />
      </div>
      <button type="submit" data-testid="save-employment-btn" disabled={loading} className="btn-gradient w-full h-14 rounded-xl font-semibold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 disabled:opacity-50">
        {loading ? <Loader2 className="h-5 w-5 animate-spin mx-auto" /> : "Continue"}
      </button>
    </form>
  );
}
